(() => {
  'use strict';
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  // Visible by default: failed JavaScript never hides content.
  if (!motion.matches && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('bp-arrive');
      observer.unobserve(entry.target);
    }), {threshold: 0.12});
    document.querySelectorAll('.bp-home .section-head,.bp-home .purpose-card,.bp-home .bp-story-card,.bp-home .trust-panel,.bp-discovery-grid>a,.bp-journey').forEach(el => {
      const siblings=[...el.parentElement.children];
      if(el.matches('.purpose-card,.bp-story-card,.bp-discovery-grid>a'))el.style.setProperty('--bp-delay',`${Math.min(siblings.indexOf(el),3)*55}ms`);
      observer.observe(el);
    });
    motion.addEventListener('change', event => {
      if (event.matches) {observer.disconnect();document.querySelectorAll('.bp-arrive').forEach(el => el.classList.remove('bp-arrive'));}
    });
  }
  const content = document.querySelector('.article-template__content');
  if (content && !content.querySelector('.bp-toc,nav[aria-label*="目次"]')) {
    const headings = [...content.querySelectorAll('h2')];
    const target = content.querySelector('.bp-auto-toc');
    if (target && headings.length >= 3) {
      const nav = document.createElement('nav');nav.setAttribute('aria-label','この記事の目次');
      const title = document.createElement('strong');title.textContent='この記事でわかること';
      const list = document.createElement('ol');
      headings.forEach((heading,index) => {
        if (!heading.id) {let id = `bp-section-${index+1}`;while(document.getElementById(id)) id+='-x';heading.id=id;}
        const li=document.createElement('li');const a=document.createElement('a');a.href=`#${heading.id}`;a.textContent=heading.textContent;li.append(a);list.append(li);
      });
      nav.append(title,list);target.append(nav);target.hidden=false;
    }
  }
  // Reading feedback uses transform only; no scroll interception or layout shifts.
  if(content){
    const progress=document.createElement('div');progress.className='bp-reading-progress';progress.setAttribute('aria-hidden','true');document.body.append(progress);
    const tocLinks=[...content.querySelectorAll('.bp-toc a[href^="#"]')];
    const sections=tocLinks.map(a=>({a,h:document.getElementById(a.hash.slice(1))})).filter(x=>x.h);
    let scheduled=false;
    const updateReading=()=>{
      scheduled=false;
      const rect=content.getBoundingClientRect();
      const distance=Math.max(1,rect.height-innerHeight+120);
      const value=Math.max(0,Math.min(1,(120-rect.top)/distance));
      progress.style.transform=`scaleX(${value})`;
      let current=null;
      for(const item of sections){if(item.h.getBoundingClientRect().top<=180)current=item.a;}
      for(const item of sections){if(item.a===current)item.a.setAttribute('aria-current','location');else item.a.removeAttribute('aria-current');}
    };
    const scheduleReading=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(updateReading);}};
    addEventListener('scroll',scheduleReading,{passive:true});addEventListener('resize',scheduleReading,{passive:true});updateReading();
  }
  const back = document.querySelector('.bp-back-top');
  if (back) {
    let queued=false;
    const update=()=>{back.hidden=scrollY<innerHeight*2;queued=false;};
    addEventListener('scroll',()=>{if(!queued){queued=true;requestAnimationFrame(update);}},{passive:true});update();
  }
})();
